// Feature flag — flip to `true` to reveal the on-site registration form.
// Kept as a code constant so a redeploy is required to open registrations.
export const CAMPS_OPEN = false;

export const TBA_COUNT = 4;
export const CAMP_DAYS = 4;
export const FEE_TIERS = ["early", "regular", "late"];
export const QTY_TIERS = ["single", "verbal", "full", "full_video"];

export const initialForm = {
  athlete_first_name: "",
  athlete_last_name: "",
  athlete_dob: "",
  athlete_sex: "",
  athlete_position: "",
  athlete_club: "",
  guardian_name: "",
  guardian_email: "",
  guardian_phone: "",
  guardian_country: "",
  camp_slug: "",
  camp_fee_tier: "",
  notes: "",
};

export const initialAddOns = {
  individual_training: { tier: "", qty: 0 },
  gk_training: { tier: "", qty: 0 },
  analyst: { tier: "", qty: 0 },
};

export const inputClass =
  "w-full bg-transparent border-0 border-b border-[#0F1B2D]/30 focus:border-[#C4A46A] focus:outline-none py-3 text-[#0F1B2D] placeholder:text-[#5E6470]";

// Prices mirror /app/backend/server.py CAMP_ADDON_PRICES
const TRAINING_PRICES = { single: 69, pack1: 249, pack2: 459 };
const ANALYST_PRICES = { verbal: 49, full: 89, full_video: 119 };

const trainingUnit = (tier, qty) =>
  tier === "single" ? TRAINING_PRICES.single * qty : TRAINING_PRICES[tier] || 0;

const analystUnit = (tier, qty) => (ANALYST_PRICES[tier] || 0) * qty;

export const computeAddonsTotal = (addOns) =>
  trainingUnit(addOns.individual_training.tier, addOns.individual_training.qty) +
  trainingUnit(addOns.gk_training.tier, addOns.gk_training.qty) +
  analystUnit(addOns.analyst.tier, addOns.analyst.qty);

// Mirror /app/backend/server.py — camp start dates + tier windows.
const CAMP_START_DATES = {
  "san-diego": new Date(Date.UTC(2027, 5, 9)),
  arkansas: new Date(Date.UTC(2027, 5, 28)),
};
const EARLY_BIRD_END = new Date(Date.UTC(2026, 11, 31));
const REGULAR_START = new Date(Date.UTC(2027, 0, 1));
const REGULAR_END = new Date(Date.UTC(2027, 2, 31));
const LATE_START = new Date(Date.UTC(2027, 3, 1));
const DAY_MS = 24 * 60 * 60 * 1000;

const todayUTC = () => {
  const d = new Date();
  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
};

export const activeTierForCamp = (slug) => {
  const start = CAMP_START_DATES[slug];
  if (!start) return null;
  const t = todayUTC();
  if (t <= EARLY_BIRD_END) return "early";
  if (t >= REGULAR_START && t <= REGULAR_END) return "regular";
  if (t >= LATE_START && t <= new Date(start.getTime() - DAY_MS)) return "late";
  return null;
};

export const hasRequiredFields = (form) =>
  [
    "athlete_first_name",
    "athlete_last_name",
    "athlete_dob",
    "guardian_name",
    "guardian_email",
    "guardian_phone",
    "camp_slug",
  ].every((k) => Boolean(form[k]));
